import type { FetchRequestError } from "@lib/errors";

import type { MutationFetcherFunctionWithShadowError } from "../types";

/**
 * Strongly type a mutation fetcher function with the error class it throws
 *
 * Since any server error is possible, this forces an intersection of the specified error type and FetchRequestError
 */
export const createMutationFetcherFunctionWithShadowError =
  <Error extends FetchRequestError>() =>
  <Arguments, Result>(fetcher: MutationFetcherFunctionWithShadowError<Error, Arguments, Result>) =>
    fetcher;
